import Link from 'next/link';
import { Post } from '@/types/models';

interface BlogPostCardProps {
  post: Post;
}

const BlogPostCard = ({ post }: BlogPostCardProps) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'Draft';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <article className="bg-card rounded-lg border border-border p-6 shadow-card transition-shadow hover:shadow-luxury">
      <div className="space-y-3">
        {/* Title */}
        <Link href={`/market-updates/${post?.slug}`}>
          <h2 className="font-heading text-3xl font-bold text-foreground hover:text-primary transition-colors">
            {post?.title}
          </h2>
        </Link>

        {/* Date */}
        <div className="text-sm font-semibold uppercase text-accent">{formatDate(post?.publishedAt)}</div>

        {/* Excerpt */}
        <p className="text-muted-foreground line-clamp-3">{post?.excerpt}</p>

        {/* Read More Link */}
        <Link
          href={`/market-updates/${post?.slug}`}
          className="inline-flex items-center text-primary hover:text-plum-deep font-semibold text-sm transition-colors"
        >
          Read more →
        </Link>
      </div>
    </article>
  );
};

export default BlogPostCard;
